import { FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import ErrorMessage from "./ErrorMessage";
import { useStore, connect } from 'src/store/connect';
import { getOptionColor } from "src/utils/utils"

interface ErrorMessagesProps { };

const ErrorMessages: FC<ErrorMessagesProps> = () => {
    const classes = useStyles();
    const state = useStore();

    const onRemoveErrorMessage = (id: string) => {
      state.removeErrorMessage(id)
    }

    const onChangeErrorMessage = (id: string, newErrorMessage: string) => {
      state.changeErrorMessage(id, newErrorMessage)
    }

    return (
      <div className={classes.root}>
        {state.flow.errorMessages?.map((errorMessage, index) => {
          return (
            <ErrorMessage
              errorMessage={errorMessage}
              order={index + 1}
              tagColoredElementStyle={getTagColoredElementStyle(index)}
              onChangeErrorMessage={onChangeErrorMessage}
              onRemoveErrorMessage={onRemoveErrorMessage}
              key={`errorMessage-${errorMessage.id}`} />
          );
        })}
      </div>
    );
};

ErrorMessages.defaultProps = { };

export default connect(ErrorMessages);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
  },
}));

const getTagColoredElementStyle = (index: number) => {
  return {
    width: "8px",
    height: "38px",
    borderRadius: "2.5px",
    backgroundColor: getOptionColor(index),
  };
};
